import React, { useState, useEffect } from 'react';

//countdown timer for PWA OTP system

function CountdownTimer({ seconds, handleZeroFunction }) {
    const [count, setCount] = useState(seconds);

    useEffect(() => {
        const timer = setInterval(() => {
            setCount(count - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [count]);

    const formatTime = (sec) => {
        const minutes = Math.floor(sec / 60);
        const seconds = sec - minutes * 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }

    if(count > 0) {
        return count
    } else {
        handleZeroFunction()
        return 0
    }
}

export default CountdownTimer;